import { TPaymentMode, TStatus } from '../../apis/finance/finance.interfaces';
import {
  TInventoryItem,
  TInventoryTransaction,
  TInventoryCategory,
} from 'src/apis/administration/administration.interfaces';

export const mockInventoryCategories: TInventoryCategory[] = [
  {
    id: 'cat-001',
    name: 'Electronics',
    description: 'Electronic devices and equipment',
    isActive: true,
    totalItems: 45,
    totalValue: 125000,
  },
  {
    id: 'cat-002',
    name: 'Furniture',
    description: 'School furniture and fixtures',
    isActive: true,
    totalItems: 120,
    totalValue: 89000,
  },
  {
    id: 'cat-003',
    name: 'Books',
    description: 'Textbooks and reference materials',
    isActive: true,
    totalItems: 500,
    totalValue: 75000,
  },
  {
    id: 'cat-004',
    name: 'Sports Equipment',
    description: 'Sports and physical education equipment',
    isActive: true,
    totalItems: 85,
    totalValue: 45000,
  },
  {
    id: 'cat-005',
    name: 'Lab Equipment',
    description: 'Science laboratory equipment',
    isActive: true,
    totalItems: 65,
    totalValue: 180000,
  },
  {
    id: 'cat-006',
    name: 'Office Supplies',
    description: 'General office and stationery items',
    isActive: true,
    totalItems: 200,
    totalValue: 15000,
  },
  {
    id: 'cat-007',
    name: 'Uniforms',
    description: 'School uniforms and accessories',
    isActive: true,
    totalItems: 300,
    totalValue: 60000,
  },
];

export const mockInventoryItems: TInventoryItem[] = [
  {
    id: 'item-001',
    itemName: 'Dell Latitude Laptop',
    category: 'ELECTRONICS',
    subCategory: 'Computers',
    description: '14-inch laptop for computer lab',
    quantity: 25,
    unit: 'pieces',
    unitPrice: 45000,
    totalValue: 1125000,
    supplier: 'Dell India Pvt Ltd',
    supplierContact: '+91-80-12345678',
    location: 'Computer Lab 1',
    minimumStock: 5,
    maximumStock: 30,
    reorderPoint: 8,
    lastRestocked: new Date('2024-01-15'),
    nextRestockDate: new Date('2024-04-15'),
    condition: 'NEW',
    isActive: true,
    purchaseDate: new Date('2024-01-10'),
    warrantyExpiryDate: new Date('2027-01-10'),
    assignedTo: 'computer-dept',
    notes: 'Windows 11 Pro, 16GB RAM, 512GB SSD',
  },
  {
    id: 'item-002',
    itemName: 'Student Desk',
    category: 'FURNITURE',
    subCategory: 'Classroom Furniture',
    description: 'Standard student desk with chair',
    quantity: 150,
    unit: 'pieces',
    unitPrice: 3500,
    totalValue: 525000,
    supplier: 'Furniture World',
    supplierContact: '+91-80-87654321',
    location: 'Classrooms 1-10',
    minimumStock: 20,
    maximumStock: 200,
    reorderPoint: 30,
    lastRestocked: new Date('2024-02-01'),
    nextRestockDate: new Date('2024-05-01'),
    condition: 'GOOD',
    isActive: true,
    purchaseDate: new Date('2023-08-15'),
    warrantyExpiryDate: new Date('2026-08-15'),
    assignedTo: 'classroom-dept',
    notes: 'Wooden desk with metal frame',
  },
  {
    id: 'item-003',
    itemName: 'Science Textbook - Class 10',
    category: 'BOOKS',
    subCategory: 'Textbooks',
    description: 'NCERT Science textbook for Class 10',
    quantity: 80,
    unit: 'pieces',
    unitPrice: 250,
    totalValue: 20000,
    supplier: 'NCERT Book Store',
    supplierContact: '+91-11-12345678',
    location: 'Library - Science Section',
    minimumStock: 10,
    maximumStock: 100,
    reorderPoint: 15,
    lastRestocked: new Date('2024-01-20'),
    nextRestockDate: new Date('2024-06-20'),
    condition: 'NEW',
    isActive: true,
    purchaseDate: new Date('2024-01-15'),
    assignedTo: 'library-dept',
    notes: 'Latest edition 2024-25',
  },
  {
    id: 'item-004',
    itemName: 'Cricket Bat',
    category: 'SPORTS',
    subCategory: 'Cricket Equipment',
    description: 'Professional cricket bat for school team',
    quantity: 15,
    unit: 'pieces',
    unitPrice: 2500,
    totalValue: 37500,
    supplier: 'Sports Equipment Co.',
    supplierContact: '+91-80-98765432',
    location: 'Sports Equipment Room',
    minimumStock: 3,
    maximumStock: 20,
    reorderPoint: 5,
    lastRestocked: new Date('2024-01-10'),
    nextRestockDate: new Date('2024-04-10'),
    condition: 'GOOD',
    isActive: true,
    purchaseDate: new Date('2023-12-01'),
    assignedTo: 'sports-dept',
    notes: 'English willow, size 6',
  },
  {
    id: 'item-005',
    itemName: 'Microscope',
    category: 'LAB_EQUIPMENT',
    subCategory: 'Biology Lab',
    description: 'Compound microscope for biology lab',
    quantity: 12,
    unit: 'pieces',
    unitPrice: 15000,
    totalValue: 180000,
    supplier: 'Lab Equipment India',
    supplierContact: '+91-80-11223344',
    location: 'Biology Lab',
    minimumStock: 2,
    maximumStock: 15,
    reorderPoint: 3,
    lastRestocked: new Date('2024-01-05'),
    nextRestockDate: new Date('2024-04-05'),
    condition: 'NEW',
    isActive: true,
    purchaseDate: new Date('2024-01-01'),
    warrantyExpiryDate: new Date('2027-01-01'),
    assignedTo: 'biology-dept',
    notes: '1000x magnification, LED illumination',
  },
  {
    id: 'item-006',
    itemName: 'A4 Paper',
    category: 'OFFICE_SUPPLIES',
    subCategory: 'Paper',
    description: 'A4 size white paper for printing',
    quantity: 100,
    unit: 'reams',
    unitPrice: 250,
    totalValue: 25000,
    supplier: 'Paper Mart',
    supplierContact: '+91-80-55667788',
    location: 'Office Store',
    minimumStock: 20,
    maximumStock: 150,
    reorderPoint: 30,
    lastRestocked: new Date('2024-02-15'),
    nextRestockDate: new Date('2024-05-15'),
    condition: 'NEW',
    isActive: true,
    purchaseDate: new Date('2024-02-10'),
    assignedTo: 'office-dept',
    notes: '80 GSM, 500 sheets per ream',
  },
  {
    id: 'item-007',
    itemName: 'School Uniform - Boys',
    category: 'UNIFORMS',
    subCategory: 'Boys Uniform',
    description: 'Standard school uniform for boys',
    quantity: 200,
    unit: 'pieces',
    unitPrice: 800,
    totalValue: 160000,
    supplier: 'Uniform Tailors',
    supplierContact: '+91-80-99887766',
    location: 'Uniform Store',
    minimumStock: 30,
    maximumStock: 250,
    reorderPoint: 50,
    lastRestocked: new Date('2024-01-25'),
    nextRestockDate: new Date('2024-04-25'),
    condition: 'NEW',
    isActive: true,
    purchaseDate: new Date('2024-01-20'),
    assignedTo: 'uniform-dept',
    notes: 'White shirt, navy blue pants, school logo',
  },
];

export const mockInventoryTransactions: TInventoryTransaction[] = [
  {
    id: 'trans-001',
    itemId: 'item-001',
    transactionType: 'PURCHASE',
    quantity: 25,
    unitPrice: 45000,
    totalAmount: 1125000,
    transactionDate: new Date('2024-01-10'),
    referenceNumber: 'PO-2024-001',
    notes: 'Bulk purchase for computer lab upgrade',
    performedBy: 'staff-001',
    paymentStatus: TStatus.PAID,
    paymentMode: TPaymentMode.BANK_TRANSFER,
    supplier: 'Dell India Pvt Ltd',
  },
  {
    id: 'trans-002',
    itemId: 'item-002',
    transactionType: 'PURCHASE',
    quantity: 50,
    unitPrice: 3500,
    totalAmount: 175000,
    transactionDate: new Date('2024-02-01'),
    referenceNumber: 'PO-2024-002',
    notes: 'Additional furniture for new classrooms',
    performedBy: 'staff-002',
    paymentStatus: TStatus.PAID,
    paymentMode: TPaymentMode.CHEQUE,
    supplier: 'Furniture World',
  },
  {
    id: 'trans-003',
    itemId: 'item-003',
    transactionType: 'PURCHASE',
    quantity: 80,
    unitPrice: 250,
    totalAmount: 20000,
    transactionDate: new Date('2024-01-15'),
    referenceNumber: 'PO-2024-003',
    notes: 'New academic year textbooks',
    performedBy: 'staff-003',
    paymentStatus: TStatus.PAID,
    paymentMode: TPaymentMode.CASH,
    supplier: 'NCERT Book Store',
  },
  {
    id: 'trans-004',
    itemId: 'item-001',
    transactionType: 'TRANSFER',
    quantity: 2,
    unitPrice: 45000,
    totalAmount: 90000,
    transactionDate: new Date('2024-02-20'),
    referenceNumber: 'TR-2024-001',
    notes: 'Transferred to admin office',
    performedBy: 'staff-001',
    paymentStatus: TStatus.N_A,
    recipient: 'admin-office',
  },
  {
    id: 'trans-005',
    itemId: 'item-006',
    transactionType: 'PURCHASE',
    quantity: 100,
    unitPrice: 250,
    totalAmount: 25000,
    transactionDate: new Date('2024-02-10'),
    referenceNumber: 'PO-2024-004',
    notes: 'Office supplies for new semester',
    performedBy: 'staff-004',
    paymentStatus: TStatus.UNPAID,
    paymentMode: TPaymentMode.BANK_TRANSFER,
    supplier: 'Paper Mart',
  },
  {
    id: 'trans-006',
    itemId: 'item-004',
    transactionType: 'DAMAGE',
    quantity: 1,
    unitPrice: 2500,
    totalAmount: 2500,
    transactionDate: new Date('2024-02-25'),
    referenceNumber: 'DMG-2024-001',
    notes: 'Cricket bat damaged during practice',
    performedBy: 'staff-005',
    paymentStatus: TStatus.N_A,
  },
];
